/** @format */

import React, { useEffect, useRef, useState } from "react";
import { IoAdd } from "react-icons/io5";
import { FaEdit, FaTrash } from "react-icons/fa"; // Import icons for edit and delete
import { AiOutlineFileProtect } from "react-icons/ai";
import { MdOutlineWifiProtectedSetup } from "react-icons/md";

import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { Link } from "react-router-dom";
import Navbar from "../../../components/navbar/navbar";
import Notification from "../../../components/notification/notification";
import moment from "moment";
import Current_vehicle_dispatches_edit from "./current_vehicle_dispatches_edit";

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = "Yes, Save",
  cancelText = "Cancel",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-gray-200 bg-opacity-80">
      <div className="p-8 bg-white rounded-lg">
        <h2 className="mb-4 text-xl font-bold">{title}</h2>
        <p>{message}</p>
        <div className="flex justify-end gap-4 mt-6">
          <button
            className="px-4 py-2 text-white bg-green-500 rounded-xl"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          <button
            className="px-4 py-2 text-gray-600 bg-white border border-gray-300 rounded-xl"
            onClick={onCancel}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

const Current_vehicle_dispatches = () => {
  const backendUrl = process.env.REACT_APP_VEHICLE_FLEET_BACKEND_URL;
  const [seletedValue, setSeletedValue] = useState({
    search_term: "",
  });
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(20); // Default rows per page
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [scheduleId, setScheduleId] = useState();
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 20,
    total: 0,
    total_pages: 0,
  });

  // Define all state variables for confirmations and forms
  const [isEditeConfirmationOpen, setIsEditeConfirmationOpen] = useState(false);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [isArrivalConfirmationOpen, setIsArrivalConfirmationOpen] =
    useState(false);
  const [isDispatchConfirmationOpen, setIsDispatchConfirmationOpen] =
    useState(false);

  // Define the handlers for each confirmation and action

  // Save form handlers
  const handleSaveForm = () => {
    // Logic to save the form
    console.log("Saving form...");
    setIsEditeConfirmationOpen(false); // Close confirmation modal after saving
  };

  const handleCloseSaveConfirmation = () => {
    setIsEditeConfirmationOpen(false); // Close the save confirmation modal
  };

  // Delete form handlers
  const handleDeleteForm = () => {
    // Logic to delete the form
    console.log("Deleting form...");
    setIsDeleteConfirmationOpen(false); // Close confirmation modal after deletion
  };

  const handleCloseDeleteConfirmation = () => {
    setIsDeleteConfirmationOpen(false); // Close the delete confirmation modal
  };

  // Arrival form handlers
  const handleArrivalForm = () => {
    // Logic to handle vehicle arrival
    console.log("Vehicle arrival handled...");
    setIsArrivalConfirmationOpen(false); // Close arrival confirmation modal after handling
  };

  const handleCloseArrivalConfirmation = () => {
    setIsArrivalConfirmationOpen(false); // Close the arrival confirmation modal
  };

  // Dispatch form handlers
  const handleDispatchForm = async () => {
    const temp = scheduleId.schedule_id;
    // Logic to handle vehicle dispatch
    console.log("Vehicle dispatch handled...");
    try {
      const response = await fetch(`${backendUrl}/dailyRoutesDispatch/dispatch?schedule_id=${temp}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setNotification({
        message: 'Updated the dispatch records successfully',
        type: "success",
      });

      console.log(response.data);

    } catch (error) {
      console.error('Error occurred during dispatch:', error);
    }

    getTableData()
    handleCloseDispatchConfirmation()

  };

  const handleCloseDispatchConfirmation = () => {
    setIsDispatchConfirmationOpen(false); // Close the dispatch confirmation modal
  };



  const handleDispatchVehicle = () => {
    setIsDispatchConfirmationOpen(true);
    // Logic for vehicle dispatch
    // console.log("Dispatching vehicle...");
  };

  const handleRowSelect = (id) => {
    console.log(id);
    if (selectedRow === id) {
      setSelectedRow(null);
      setDropdownVisible(false);
     
    } else {
      setSelectedRow(id);
      setScheduleId(id)
      setDropdownVisible(true);
    }
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
    getTableData();
  };

  const editePopup = () => {
    setIsOpenEdit(!isOpenEdit);
    getTableData();
  };

  const handleEdit = () => {
    setIsOpenEdit(true);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.put(
        `${backendUrl}/vehicle/removeVehicle`,
        {}, // Empty body as PUT requires some data
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            vehicle_id: selectedRow.vehicle_id, // Passing the vehicle_id as a query param
          },
        }
      );
      // Success response
      setNotification({
        message: response.data.message || "Vehicle deactivated successfully!",
        type: "success",
      });

      // Optionally refresh the data
      getTableData();
    } catch (error) {
      console.error("Error deleting vehicle:", error);

      setNotification({
        message:
          error.response?.data?.error || "Delete failed, vehicle not found",
        type: "error",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSeletedValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function to handle fetching table data
  const getTableData = async () => {
    try {
      const params = {
        page_size: rowsPerPage,
        page: pagination.current_page,
        search_term: seletedValue.search_term,
      };

      console.log(params);

      const response = await axios.get(`${backendUrl}/dailyRoutesDispatch/`, {
        params,
      });

      console.log("----vehicle------");
      console.log(response.data);
      console.log("----vehicle------");

      // Ensure you set both data and pagination state
      if (response.data) {
        setTableData(response.data.data); // Set the data array
        setPagination(response.data.pagination); // Set the pagination info
      } else {
        console.error("Unexpected response format:", response.data);
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching sample details:", error);
      setTableData([]);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPagination((prevPagination) => ({
      ...prevPagination,
      current_page: 1, // Reset to first page whenever rows per page changes
    }));
  };

  const PdfExport = () => {
    const doc = new jsPDF();
    doc.text("Vehicle Dispatches", 20, 10);
    doc.autoTable({
      head: [['Gate Pass Id', 'Vehicle Id', 'Driver Name', 'Departure Location', 'Destination Location', 'Departure Date']],
      body: tableData.map(row => [
        row.gate_pass_id,
        row.vehicle_id,
        row.driver_name,
        row.departure_location,
        row.destination_location,
        moment(row.departure_date).format('DD/MM/YYYY')
      ]),
    });
    doc.save('vehicle_dispatches.pdf');
  };
  

  const ExcelExport = () => {
    const csvData = tableData.map(row => ({
      'Gate Pass Id': row.gate_pass_id,
      'Vehicle Id': row.vehicle_id,
      'Driver Name': row.driver_name,
      'Departure Location': row.departure_location,
      'Destination Location': row.destination_location,
      'Departure Date': moment(row.departure_date).format('DD/MM/YYYY')
    }));
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "vehicle_dispatches.csv");
    link.click();
  };
  

  // Handler for closing dropdown and deselecting row on outside click
  const handleClickOutside = (event) => {
    if (actionsRef.current && !actionsRef.current.contains(event.target)) {
      setSelectedRow(null);
      setDropdownVisible(false);
    }
  };

  const actionsRef = useRef(null); // Ref for the "actions" element

  // Close dropdown and deselect row if clicking outside the table
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle Notification Close
  const handleCloseNotification = () => {
    setNotification({ message: "", type: "" });
  };

  // Call the API whenever rowsPerPage or currentPage changes
  useEffect(() => {
    getTableData();
  }, [
    rowsPerPage,
    pagination.current_page,
    seletedValue,
    seletedValue.search_term,
  ]);

  return (
    <div className="mx-10 mt-5 text-xl">
      <div className="">
        <div className="mx-10 mt-5 -ml-1">
          <Navbar />
          <div className="flex items-center justify-between mt-6 ">
            {/* Added negative margin-left */}
            <div>
              <p className="text-[30px] font-semibold">
                Current vehicle dispatches
              </p>
              <p className="text-[15px] font-semibold text-[#ABDCB0]">
                Gate Pass Request Dispatch
              </p>
            </div>
            <div className="flex items-center gap-6">
              <div>
                <div className="text-[#069855] text-[20px] font-bold">
                  {/* {currentDate} */}
                </div>
              </div>
              <div className="text-[20px] font-bold">{/* {currentTime} */}</div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:gap-4 mt-6">
            {/* Search Box for Account Name */}
            <div className="w-full md:w-[350px]">
              <input
                type="text"
                placeholder="search gate pas Id"
                name="search_term"
                value={seletedValue.search_term}
                onChange={handleChange}
                className="w-full p-2 border border-black rounded focus:ring-2"
              />
            </div>

            {/* Notification Alert */}
            <Notification
              message={notification.message}
              type={notification.type}
              onClose={handleCloseNotification}
            />

            {/* Button Container */}
            <div
              className="relative flex items-center gap-4 ml-auto"
              id="actions"
              ref={actionsRef}
            >
              {/* <button
                className="flex items-center gap-2 px-4 py-2 text-white bg-gradient-to-r from-red-400 to-red-600 rounded hover:from-red-500 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                onClick={PdfExport}
              >
                <IoAdd className="text-xl" />
                PDF Export
              </button> */}
              <button
                className="flex items-center gap-2 px-4 py-2 text-white bg-gradient-to-r from-green-400 to-green-600 rounded hover:from-green-500 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                onClick={ExcelExport}
              >
                <IoAdd className="text-xl" />
                Excel Export
              </button>
              {selectedRow ? (
                // Action Dropdown
                <div className="relative">
                  <button
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                    className="flex items-center gap-2 px-4 py-2 text-white bg-indigo-600 rounded hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    Actions
                  </button>
                  {dropdownVisible && (
                    <div className="absolute right-0 z-20 mt-2 bg-white border border-black rounded shadow-lg">
                      {/* Delete Button - Always shown */}
                      {/* <button
                        onClick={handleDelete}
                        className="flex items-center w-full px-4 py-2 text-xl text-black hover:bg-gray-100"
                      >
                        <FaTrash className="mr-2" /> Delete
                      </button> */}

                      {/* Show Arraival button only when status is 'in_progress' or 'SCHEDULED' */}
                      {selectedRow.status === "SCHEDULED" && (
                        <button
                          onClick={handleDispatchVehicle}
                          className="flex items-center w-full px-4 py-2 text-xl text-black hover:bg-gray-100"
                        >
                          <MdOutlineWifiProtectedSetup className="mr-2" />
                          Dispatch
                        </button>
                      )}


                      {/* Show Dispatch Vehicle button only when status is 'SCHEDULED' */}
                      {selectedRow.status === "IN PROGRESS" && (
                        <button
                          onClick={handleEdit}
                          className="flex items-center w-full px-4 py-2 text-xl text-black hover:bg-gray-100"
                        >
                          <FaEdit className="mr-2" /> Edit
                        </button>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="my-4 overflow-x-auto mt-10 z-auto">
        {/* Scrollable Table Container with Increased Height */}
        <div className="max-h-[600px] overflow-y-auto">
          {/* TailwindCSS Table */}
          <table className="min-w-full bg-white border border-black ">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Gate Pass Id
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Vehicle Id
                </th>
                {/* <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 z-[10]">
                  Manager Id
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 z-[10]">
                  Department
                </th> */}
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Driver Name
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Departure Location
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Destination Location
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Departure Date
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Departure Time
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200">
                  Arrived Date
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Arrived_time
                </th>
                <th className="px-6 py-3 font-bold text-left text-gray-500 uppercase border-b border-gray sticky top-0 bg-gray-200 ">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    selectedRow === row
                      ? "bg-blue-600 text-white"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => handleRowSelect(row)}
                >
                  <td className="px-6 py-4 border-b border-black">
                    {row.schedule_id}
                  </td>
                  <td className="px-6 py-4 border-b border-black">
                    {row.vehicle_id}
                  </td>

                  {/* <td className="px-6 py-4 border-b border-black">
                    {row.manager_id}
                  </td>
                  <td className="px-6 py-4 border-b border-black">
                    {row.department}
                  </td> */}
                  <td className="px-6 py-4 border-b border-black">
                    {row.driver_name}
                  </td>

                  <td className="px-6 py-4 border-b border-black">
                    {row.departure_location}
                  </td>
                  <td className="px-6 py-4 border-b border-black">
                    {row.destination_location}
                  </td>

                  <td className="px-6 py-4 border-b border-black">
                    {row.departure_date}
                  </td>
                  <td className="px-6 py-4 border-b border-black">
                    {row.departure_time}
                  </td>

                  <td className="px-6 py-4 border-b border-black">
                    {row.arrived_date}
                  </td>
                  <td className="px-6 py-4 border-b border-black">
                    {row.arrived_time}
                  </td>
                  <td
                    className={`px-6 py-4 border-b border-black ${
                      row.status === "COMPLETED"
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {row.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center mt-4 gap-2">
        {[20, 40, 60].map((size) => (
          <button
            key={size}
            onClick={() => handleRowsPerPageChange(size)}
            className={`px-4 py-2 ${
              rowsPerPage === size
                ? "bg-green-600 text-white" // Active button with green background and white text
                : "bg-green-300 text-black" // Inactive button with lighter green background and black text
            } rounded hover:bg-green-500`} // Hover effect for both states
          >
            {size}
          </button>
        ))}
        <button
          onClick={() =>
            setPagination((prevPagination) => ({
              ...prevPagination,
              currentPage: Math.min(
                prevPagination.currentPage + 1,
                prevPagination.totalPages
              ),
            }))
          }
          disabled={pagination.currentPage >= pagination.totalPages}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600"
        >
          Load More
        </button>
      </div>

      {/* Add Chart Account Popup */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="w-3/4 p-6 bg-white rounded-lg shadow-lg">
            {/* <AddVehiclePopup togglePopup={togglePopup} /> */}
          </div>
        </div>
      )}

      {/* Edit Chart Account Popup */}
      {isOpenEdit && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="w-3/4 p-6 bg-white rounded-lg shadow-lg">
            <Current_vehicle_dispatches_edit
              toggleEditPopup={editePopup}
              dispatchesData={selectedRow}
            />
          </div>
        </div>
      )}

      {/* Save Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={isEditeConfirmationOpen}
        title="Confirm Save"
        message="Are you sure you want to save the form data?"
        onConfirm={handleSaveForm}
        onCancel={handleCloseSaveConfirmation}
      />

      {/* Delete Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={isDeleteConfirmationOpen}
        title="Confirm Delete"
        message="Are you sure you want to delete this item?"
        onConfirm={handleDeleteForm}
        onCancel={handleCloseDeleteConfirmation}
        confirmText="Yes, Delete"
      />

      {/* Arrival Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={isArrivalConfirmationOpen}
        title="Confirm Arrival"
        message="Are you sure the vehicle has arrived?"
        onConfirm={handleArrivalForm}
        onCancel={handleCloseArrivalConfirmation}
        confirmText="Yes, Confirm Arrival"
      />

      {/* Dispatch Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={isDispatchConfirmationOpen}
        title="Confirm Dispatch"
        message="Are you sure you want to dispatch the vehicle?"
        onConfirm={handleDispatchForm}
        onCancel={handleCloseDispatchConfirmation}
        confirmText="Yes, Dispatch"
      />
    </div>
  );
};

export default Current_vehicle_dispatches;
